// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qTLG","questions":"styles_questions__1VCYv","footer":"styles_footer__2e4iw"};